import {webRequest, webNoTokenRequest} from '../api'

// 推薦房客選單
export function getRecommandTenantList() {
    return webRequest({
        url:'/v1/oauth/management/house/tenant/recommendation',
        method:'get',
    })
}

// 刪除推薦房客資料 
export function delRecommandTenant(data) {
    return webRequest({
        url:'/v1/oauth/management/house/tenant/recommendation/delete',
        method:'post',
        data: data,
    })
}



// WEBPACK FOOTER //
// ./src/apis/company/recommandTenant.js